import {fetch} from "../../utils/dataAccess";

export async function getRetailerStockAlerts(startDate, endDate) {
    const params = new URLSearchParams({ startDate, endDate });
    const response = await fetch(`/dashboard/retailer_stock_alerts?${params}`);
    return response.json();
}
